var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "mr-t-10" }, [
        _c("p", { staticClass: "discription" }, [
          _vm._v(
            "新規商品登録時（Amazonから追加画面）に既定で表示される受取金額の掛率を変更できます。"
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "discription" }, [
          _vm._v("Amazon価格に対する掛率を入力して下さい。")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "discription" }, [
          _vm._v("※すでに登録済みの受取金額には影響しません。")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("form", { attrs: { "data-vv-scope": "setting-form" } }, [
          _c("div", { staticClass: "form-group flexbox" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "flex-item flex-input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.offerPriceRate,
                    expression: "offerPriceRate",
                    modifiers: { number: true }
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|numeric|min_value:1|max_value:1000",
                    expression: "'required|numeric|min_value:1|max_value:1000'"
                  }
                ],
                staticClass: "offer-rate-form form-control text-right",
                attrs: {
                  type: "text",
                  "data-vv-as": "受取金額倍率",
                  "data-vv-name": "offerPriceRate",
                  "data-vv-scope": "setting-form"
                },
                domProps: { value: _vm.offerPriceRate },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.offerPriceRate = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v("%\n          ")
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("setting-form.offerPriceRate"),
                    expression: "errors.has('setting-form.offerPriceRate')"
                  }
                ],
                staticClass: "text-danger",
                staticStyle: { display: "block" }
              },
              [
                _vm._v(
                  "※" + _vm._s(_vm.errors.first("setting-form.offerPriceRate"))
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mr-t-20" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-warning w-120",
                attrs: { disabled: _vm.disabled },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.updateSetting()
                  }
                }
              },
              [
                _vm._v("\n            更新\n            "),
                _c("i", {
                  staticClass: "fa fa-check text-size-16",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row example" }, [
      _c("span", [_vm._v("例）受取金額掛率：90%  の場合")]),
      _vm._v(" "),
      _c("p", { staticClass: "example-rate" }, [
        _vm._v("Amazon価格：1000円"),
        _c("span", { staticClass: "example-arrow" }, [_vm._v("->")]),
        _vm._v("受取金額(税込)：900円")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass:
          "control-label flex-item flex-lable flexbox justify-between label-width-3"
      },
      [
        _vm._v("受取金額掛率\n            "),
        _c("span", { staticClass: "text-danger m-r-sm" }, [_vm._v("＊")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f2e0d44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f2e0d44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAmazon/ReceiveAmountSetting.vue
// module id = null
// module chunks = 